import React from "react";
import { useTranslation } from "react-i18next";
import "./ErrorMessageModalComponent.css";
import { useHistory } from "react-router-dom";
import {URL_LOGIN} from "../Routes/Location";
import {MULTITENANT_CONSTANTS, TENANT} from "../../Resources/Multitenant/tenantConstants";
import {useKeycloak} from "@react-keycloak/web";
import DOMPurify from 'dompurify';
import { isCordovaAvailable } from "../../Utils/secureStorageUtil";

const ErrorMessageModalComponent = ({
  textTitle = "error.modal.common.title",
  textBody = "error.modal.rating.message",
    textButton = "global.button.go.back",
  url = null,
  onClose = null,
    action = null,
    showButtonAction = true,
}) => {
  const { t } = useTranslation();
  const translation = t(textTitle, { defaultValue: null }); // Intenta obtener la traducción

  const history = useHistory();
  const { keycloak} = useKeycloak();
  const sanitizedHTML = DOMPurify.sanitize(textTitle);

  const handleActionModal = () => {
    if (!!url && url !== URL_LOGIN) {
      history.push(url);
    } else if (url === URL_LOGIN) {
      if (isCordovaAvailable()) {
        history.push(URL_LOGIN);
      } else {
        keycloak.login({ locale: MULTITENANT_CONSTANTS[TENANT]?.defaultLocale });
      }
    } else if (action) {
      action();
    } else {
      onClose && onClose();
    }
  };

  return (
    <div className="ModalBackground">
      <div className="ErrorMessageModal">
        {translation ?
            <strong className={"ErrorModalTitle"}>{t(textTitle)}</strong>
            :
            <span className="ErrorModalTitle" dangerouslySetInnerHTML={{__html: sanitizedHTML}}/>
        }
        <div className={"ModalContent"}>
          <p>{t(textBody)}</p>
        </div>
        <div className="ButtonContainer">
          {showButtonAction &&
              <button onClick={handleActionModal} className="BotonVer BotonVerV2">
                {t(textButton)}
              </button>
          }
          {!!onClose &&
              <button onClick={onClose} className="BotonVer BotonVerV2 BotonVerSecondary">
                {t("global.button.close")}
              </button>
          }
        </div>
      </div>
    </div>
  );
};

export default ErrorMessageModalComponent;
